module.exports = __webpack_public_path__ + "img/xc0706.506694ca.png";